import script from "./contactUsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./contactUsPage.vue?vue&type=script&setup=true&lang=js"

import "./contactUsPage.vue?vue&type=style&index=0&id=4e07b21f&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e07b21f"]])

export default __exports__